import { VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';

const PATH = '/onboarding/';
const PATH_JOINHOLDER_ACCESS = `${PATH}acceso-interviniente`;
const PATH_JOINHOLDER_ACCESS_NO_CLIENT = `${PATH}inicio-interviniente-no-cliente`;
const PATH_JOINHOLDER_LOGIN = `${PATH}acceso-al-area-privada/`;
const PATH_OPEN_YOUR_ACCOUNT = `${PATH}abre-tu-cuenta/`;
const PATH_RESIDENT_RESTRICTION = `${PATH}abre-tu-cuenta/no-residente/`;
const PATH_MINOR = `${PATH}abre-tu-cuenta/menor-de-edad/`;

const WELCOME_CARD = 'card-bienvenida';

const PATH_CONTACT = `${PATH}completa-tus-datos-generales/`;
const PATH_CONTACT_WELCOME_CARD = `${PATH}completa-tus-datos-generales/${WELCOME_CARD}`;

const PATH_PROFESSION = `${PATH}tu-actividad/`;
const PATH_PROFESSION_WELCOME_CARD = `${PATH}tu-actividad/${WELCOME_CARD}`;
const PATH_DEPOSIT_CONFIG_WELCOME_CARD = `${PATH}deposito-configuracion/${WELCOME_CARD}`;

const PATH_CONTRACT = `${PATH}contrato/`;
const PATH_CONTRACT_WELCOME_CARD = `${PATH}contrato/${WELCOME_CARD}`;

const PATH_DOCUMENTATION = `${PATH}documentacion/`;
const PATH_DOCUMENTATION_WELCOME_CARD = `${PATH}documentacion/${WELCOME_CARD}`;

const PATH_DOCUMENTATION_FINISHED = `${PATH}documentacion/finalizado/`;
const PATH_DOCUMENTATION_FINISHED_WELCOME_CARD = `${PATH}documentacion/finalizado/${WELCOME_CARD}`;
const PATH_DOCUMENTATION_RETRY = `${PATH_DOCUMENTATION}revision`;

const PATH_CONTACT_CLIENT = `${PATH}inicio-interviniente-cliente/`;
const PATH_ADD_JOINHOLDER = `${PATH}intervinientes/inclusion-intervinientes`;
const PATH_JOINHOLDER_CONFIRMATION = `${PATH}intervinientes/confirmacion`;
const PATH_STANDBY_JOINHOLDER = `${PATH}standby-datos-intervinientes`;
const PATH_CREATE_NEW_CLIENT = `${PATH}creacion-cliente-nuevo/`;

const IDENTITY_CONST = 'identidad';
const PATH_IDENTITY = `${PATH}${IDENTITY_CONST}/`;
const PATH_IDENTITY_WELCOME_CARD = `${PATH}${IDENTITY_CONST}/${WELCOME_CARD}`;

const PATH_IDENTITY_VIDEOCALL_EVENT = `${IDENTITY_CONST}/videoconferencia/`;
const PATH_IDENTITY_VIDEOCALL = `${PATH}${PATH_IDENTITY_VIDEOCALL_EVENT}`;
const PATH_IDENTITY_VIDEOCALL_FINISHED = `${PATH}${PATH_IDENTITY_VIDEOCALL_EVENT}finalizado/`;
const PATH_IDENTITY_VIDEOCALL_START = `${PATH}${PATH_IDENTITY_VIDEOCALL_EVENT}comienzo/`;
const PATH_IDENTITY_VIDEOCALL_CALLCENTER = `${PATH}${PATH_IDENTITY_VIDEOCALL_EVENT}callcenter/`;
const PATH_IDENTITY_VIDEOCALL_NON_EXCLUSIVE = `${PATH}${PATH_IDENTITY_VIDEOCALL_EVENT}no-exclusivo/`;
const PATH_IDENTITY_VIDEOCALL_BLOCKED = `${PATH}${PATH_IDENTITY_VIDEOCALL_EVENT}bloqueado/`;
const PATH_IDENTITY_VIDEOCALL_BROWSER_ERROR = `${PATH_IDENTITY_VIDEOCALL_EVENT}error/navegador`;

const PATH_IDENTITY_VIDEOSELFIE_EVENT = `${IDENTITY_CONST}/videoselfie/`;
const PATH_IDENTITY_VIDEOSELFIE = `${PATH}${PATH_IDENTITY_VIDEOSELFIE_EVENT}`;
const PATH_IDENTITY_VIDEOSELFIE_FINISHED = `${PATH}${PATH_IDENTITY_VIDEOSELFIE_EVENT}finalizado/`;
const PATH_IDENTITY_VIDEOSELFIE_START = `${PATH}${PATH_IDENTITY_VIDEOSELFIE_EVENT}comienzo/`;
const PATH_IDENTITY_VIDEOSELFIE_CALLCENTER = `${PATH}${PATH_IDENTITY_VIDEOSELFIE_EVENT}callcenter/`;
const PATH_IDENTITY_VIDEOSELFIE_NON_EXCLUSIVE = `${PATH}${PATH_IDENTITY_VIDEOSELFIE_EVENT}no-exclusivo/`;
const PATH_IDENTITY_VIDEOSELFIE_BLOCKED = `${PATH}${PATH_IDENTITY_VIDEOSELFIE_EVENT}bloqueado/`;
const PATH_IDENTITY_VIDEOSELFIE_BROWSER_ERROR = `${PATH_IDENTITY_VIDEOSELFIE_EVENT}error/navegador`;

const PATH_IDENTITY_IBAN_EVENT = `${IDENTITY_CONST}/iban/`;
const PATH_IDENTITY_IBAN = `${PATH}${PATH_IDENTITY_IBAN_EVENT}`;
const PATH_IDENTITY_IBAN_FINISHED = `${PATH}${PATH_IDENTITY_IBAN_EVENT}finalizado/`;
const PATH_IDENTITY_IBAN_WAITING = `${PATH}${PATH_IDENTITY_IBAN_EVENT}en-espera/`;

const PATH_IDENTITY_COURIER_EVENT = `${IDENTITY_CONST}/mensajero/`;
const PATH_IDENTITY_COURIER = `${PATH}${PATH_IDENTITY_COURIER_EVENT}`;
const PATH_IDENTITY_COURIER_SCHEDULE = `${PATH}${PATH_IDENTITY_COURIER_EVENT}agendar/`;
const PATH_IDENTITY_COURIER_SCHEDULED = `${PATH}${PATH_IDENTITY_COURIER_EVENT}agendado/`;
const PATH_IDENTITY_COURIER_FINISHED = `${PATH}${PATH_IDENTITY_COURIER_EVENT}finalizado/`;

const PATH_IDENTITY_POST_OFFICE_EVENT = `${IDENTITY_CONST}/correo/`;
const PATH_IDENTITY_POST_OFFICE = `${PATH}${PATH_IDENTITY_POST_OFFICE_EVENT}`;
const PATH_IDENTITY_POST_OFFICE_MAP = `${PATH}${PATH_IDENTITY_POST_OFFICE_EVENT}mapa/`;
const PATH_IDENTITY_POST_OFFICE_SELECTED = `${PATH}${PATH_IDENTITY_POST_OFFICE_EVENT}seleccionado/`;
const PATH_IDENTITY_POST_OFFICE_FINISHED = `${PATH}${PATH_IDENTITY_POST_OFFICE_EVENT}finalizado/`;

const PATH_IDENTITY_TRANSFER_EVENT = `${IDENTITY_CONST}/transferencia`;
const PATH_IDENTITY_TRANSFER = `${PATH}${PATH_IDENTITY_TRANSFER_EVENT}`;

const PATH_CONTRACT_FINISHED = `${PATH}contrato/finalizado/`;
const PATH_EXIT = `${PATH}salir/`;
const PATH_MODAL_EXIT = `${PATH}modal-salir/`;
const PATH_ERROR = `${PATH}error/`;
const PATH_JOINHOLDER_ERROR = `${PATH}cuentaconjunta/error/`;
const PATH_ERROR_404 = `${PATH}error-404/`;
const PATH_ERROR_NEW_PRODUCT = `${PATH}nuevo-producto/`;
const PATH_SESSION_COUNT_DAWN = `${PATH}sesion-cuenta-regresiva`;
const PATH_SESSION_TIMEOUT = `${PATH}sesion-espirada`;
const PATH_SESSION_OVERWRITE = `${PATH}sesion-reemplazada`;

const PATH_CONFIG_CARD = `${PATH}personaliza-tu-tarjeta`;
const PATH_CONFIG_CARD_WELCOME_CARD = `${PATH}personaliza-tu-tarjeta/${WELCOME_CARD}`;

const PATH_CREDIT_CARD_ONBOARDING = `${PATH}creditCard`;
const CREDIT_CARD_TAG = 'contrata-tarjeta-credito';
const PATH_CREDIT_CARD = PATH + CREDIT_CARD_TAG;
const CREDIT_CARD_INFO_PATH = `${CREDIT_CARD_TAG}-info`;
const PATH_CREDIT_CARD_INFO = `${PATH_CREDIT_CARD}-info`;
const PATH_CREDIT_CARD_INFO_WELCOME_CARD = `${PATH_CREDIT_CARD}-info` + `/${WELCOME_CARD}`;

const CREDIT_CARD_PATH = 'contrata-gratis-tu-tarjeta-de-credito';
const PATH_CREDIT_CARD_WELCOME_CARD = `${PATH + CREDIT_CARD_PATH}/${WELCOME_CARD}`;

const PATH_ROBO = `${PATH}robo/`;
const PATH_GBI = `${PATH}gbi/`;
const PATH_PIN_CARD = `${PATH}tarjeta-pin`;
const PATH_SELECT_CARD = `${PATH}tarjeta-seleccionar`;
const PATH_SELECT_CARD_WECOME_CARD = `${PATH_SELECT_CARD}/${WELCOME_CARD}`;

const PATH_ROBO_TI = `${PATH_ROBO}test-de-idoneidad/`;
const PATH_ROBO_TI_WECOME_CARD = `${PATH_ROBO}test-de-idoneidad/${WELCOME_CARD}`;

const PATH_GBI_TI = `${PATH_GBI}test-de-idoneidad/`;
const PATH_ROBO_INVESTMENT_PLAN = `${PATH_ROBO}estrategia-de-inversion/`;
const PATH_ROBO_INVESTMENT_PLAN_WELCOME_CARD = `${PATH_ROBO}estrategia-de-inversion/${WELCOME_CARD}`;

const PATH_GBI_INVESTMENT_PLAN = `${PATH_GBI}estrategia-de-inversion/`;
const PATH_GBI_OBJECTIVE_CONFIGURATION = `${PATH_GBI}configura-tu-objetivo/`;
const PATH_RA_REJECTED = 'robo advisor rechazado';

const TRANSFER_OTP_PATH_TAG = 'otp-ibanid';
const TRANSFER_OTP_PATH_STEP = 'documentacion/ibanid';
const PATH_TRANSFER_VERIFICATION = `${PATH}transferencia-verificacion`;

const TRANSFER_OTP_PATH = PATH_DOCUMENTATION + TRANSFER_OTP_PATH_TAG;
const PATH_TRANSFER_VERIFICATION_WELCOME_CARD = `${PATH_TRANSFER_VERIFICATION}/${WELCOME_CARD}`;

const TRANSFER_OTP_PATH_WELCOME_CARD = `${TRANSFER_OTP_PATH}/${WELCOME_CARD}`;

const PATH_ARES_LOAN = 'prestamo-sin-cuenta';
const PATH_DEPOSIT_CONFIGURATION = `${PATH}deposito-configuracion`;

const PATH_SIGNATURE_KEY = `${PATH}clave-firma`;
const PATH_SIGNATURE_KEY_WELCOME_CARD = `${PATH_SIGNATURE_KEY}/${WELCOME_CARD}`;

const LOGALTY_CONTRACT_PATH = `${PATH}step7/contract`;
const LOGALTY_CONTRACT_START_PATH = `${PATH}contract/start`;

const customUtagOptionsResolver = opts => {
    return {
        ...opts,
        tipoProceso: 'onboarding',
    };
};

const IDENTITY_VIDEOS_RECORD_TAG = {
    [VIDEO_CALL]: 'videoconferencia',
    [VIDEO_SELFIE]: 'videoselfie',
};

export default {
    LOGALTY_CONTRACT_START_PATH,
    LOGALTY_CONTRACT_PATH,
    TRANSFER_OTP_PATH_WELCOME_CARD,
    TRANSFER_OTP_PATH_STEP,
    TRANSFER_OTP_PATH,
    TRANSFER_OTP_PATH_TAG,
    IDENTITY_VIDEOS_RECORD_TAG,
    PATH,
    PATH_JOINHOLDER_ACCESS,
    PATH_JOINHOLDER_ACCESS_NO_CLIENT,
    PATH_JOINHOLDER_LOGIN,
    PATH_OPEN_YOUR_ACCOUNT,
    PATH_RESIDENT_RESTRICTION,
    PATH_MINOR,
    PATH_CONTACT,
    PATH_CONTACT_CLIENT,
    PATH_CONTACT_WELCOME_CARD,
    PATH_ADD_JOINHOLDER,
    PATH_JOINHOLDER_CONFIRMATION,
    PATH_STANDBY_JOINHOLDER,
    PATH_CREATE_NEW_CLIENT,
    PATH_PROFESSION,
    PATH_PROFESSION_WELCOME_CARD,
    PATH_DEPOSIT_CONFIG_WELCOME_CARD,
    PATH_IDENTITY,
    PATH_IDENTITY_WELCOME_CARD,
    PATH_IDENTITY_VIDEOCALL,
    PATH_IDENTITY_VIDEOCALL_FINISHED,
    PATH_IDENTITY_VIDEOCALL_START,
    PATH_IDENTITY_TRANSFER,
    PATH_IDENTITY_VIDEOCALL_CALLCENTER,
    PATH_IDENTITY_VIDEOCALL_NON_EXCLUSIVE,
    PATH_IDENTITY_VIDEOCALL_BLOCKED,
    PATH_IDENTITY_IBAN,
    PATH_IDENTITY_IBAN_FINISHED,
    PATH_IDENTITY_IBAN_WAITING,
    PATH_IDENTITY_COURIER,
    PATH_IDENTITY_COURIER_SCHEDULE,
    PATH_IDENTITY_COURIER_SCHEDULED,
    PATH_IDENTITY_COURIER_FINISHED,
    PATH_IDENTITY_POST_OFFICE,
    PATH_IDENTITY_POST_OFFICE_MAP,
    PATH_IDENTITY_POST_OFFICE_SELECTED,
    PATH_IDENTITY_POST_OFFICE_FINISHED,
    PATH_CONTRACT,
    PATH_CONTRACT_WELCOME_CARD,
    PATH_CONTRACT_FINISHED,
    PATH_DOCUMENTATION,
    PATH_DOCUMENTATION_WELCOME_CARD,
    PATH_DOCUMENTATION_FINISHED,
    PATH_DOCUMENTATION_FINISHED_WELCOME_CARD,
    PATH_DOCUMENTATION_RETRY,
    PATH_EXIT,
    PATH_MODAL_EXIT,
    PATH_ERROR,
    PATH_JOINHOLDER_ERROR,
    PATH_ERROR_404,
    PATH_ERROR_NEW_PRODUCT,
    PATH_SESSION_COUNT_DAWN,
    PATH_SESSION_TIMEOUT,
    PATH_SESSION_OVERWRITE,
    PATH_CONFIG_CARD,
    PATH_CREDIT_CARD,
    PATH_ROBO,
    PATH_GBI,
    PATH_PIN_CARD,
    PATH_SELECT_CARD,
    PATH_SELECT_CARD_WECOME_CARD,
    PATH_ROBO_TI,
    PATH_GBI_TI,
    PATH_ROBO_INVESTMENT_PLAN,
    PATH_GBI_INVESTMENT_PLAN,
    PATH_GBI_OBJECTIVE_CONFIGURATION,
    PATH_RA_REJECTED,
    PATH_IDENTITY_IBAN_EVENT,
    PATH_IDENTITY_POST_OFFICE_EVENT,
    PATH_IDENTITY_TRANSFER_EVENT,
    PATH_IDENTITY_VIDEOCALL_EVENT,
    PATH_IDENTITY_COURIER_EVENT,
    PATH_IDENTITY_VIDEOCALL_BROWSER_ERROR,
    IDENTITY_CONST,
    PATH_CREDIT_CARD_ONBOARDING,
    CREDIT_CARD_TAG,
    customUtagOptionsResolver,
    PATH_CONFIG_CARD_WELCOME_CARD,
    PATH_CREDIT_CARD_WELCOME_CARD,
    PATH_ROBO_INVESTMENT_PLAN_WELCOME_CARD,
    PATH_ROBO_TI_WECOME_CARD,
    PATH_IDENTITY_VIDEOSELFIE_EVENT,
    PATH_IDENTITY_VIDEOSELFIE,
    PATH_IDENTITY_VIDEOSELFIE_FINISHED,
    PATH_IDENTITY_VIDEOSELFIE_START,
    PATH_IDENTITY_VIDEOSELFIE_CALLCENTER,
    PATH_IDENTITY_VIDEOSELFIE_NON_EXCLUSIVE,
    PATH_IDENTITY_VIDEOSELFIE_BLOCKED,
    PATH_IDENTITY_VIDEOSELFIE_BROWSER_ERROR,
    PATH_CREDIT_CARD_INFO,
    CREDIT_CARD_PATH,
    CREDIT_CARD_INFO_PATH,
    PATH_CREDIT_CARD_INFO_WELCOME_CARD,
    PATH_ARES_LOAN,
    PATH_SIGNATURE_KEY,
    PATH_SIGNATURE_KEY_WELCOME_CARD,
    PATH_DEPOSIT_CONFIGURATION,
    PATH_TRANSFER_VERIFICATION_WELCOME_CARD,
};
